export enum PermissionResourceType {
    Global = "Global",
    Users = "Users",
    Brands = "Brands",
    Products = "Products",
    Packages = "Packages",
    MasterData = "MasterData",
    Accounts = "Accounts"
}
